<template>
  <div class="key-contacts" v-if="activeLocationData && activeLocationData.contact_point && activeLocationData.contact_point.contacts">
    <div class="container">
      <div class="row key-contacts__header">
        <div class="col-s-12">
          <h2>{{ activeLocationData.contact_point.title }}</h2>
        </div>
      </div>
      <div class="row">
        <div
          class="col-l-3 col-m-6 col-s-12 key-contacts__item"
          v-for="(contact, i) in activeLocationData.contact_point.contacts"
          :key="i"
        >
          <div
            class="key-contacts__departament"
            v-if="contact.departament"
          >{{ contact.departament }}</div>
          <div class="key-contacts__details">
            <div class="key-contacts__name" v-if="contact.name">{{ contact.name }}</div>
            <div class="key-contacts__telephone" v-if="contact.telephone">{{ contact.telephone }}</div>
            <div class="key-contacts__email" v-if="contact.email"><a :href="'mailto:'+contact.email">{{ contact.email }}</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "key-contacts",
  props: ["activeLocationData"]
};
</script>



// WEBPACK FOOTER //
// KeyContacts.vue?77ee08ca